jQuery(function($){

    function init_search(){

        let btn = document.getElementById('search-trigger');

        if(btn){
            btn.addEventListener( 'click', hanleSearchClick );
        }
        
        let cross = document.getElementById('close-search');
        
        if(cross){
            cross.addEventListener( 'click', closeSearch );
        }

    }

    function hanleSearchClick(e){

        let btn = e.currentTarget;

        if (!document.startViewTransition) {
            return btn.classList.contains('is-open') ? closeSearch() : openSearch();
        }

        // startViewTransition is what does the fading effect
        document.startViewTransition( () => btn.classList.contains('is-open') ? closeSearch() : openSearch() );

    }
    

    function openSearch(){
        document.getElementById('search-trigger').classList.add('is-open');
        document.getElementById('searchform').style.display = "block";
        window.addEventListener('keydown', handleSearchKeypress );
    }
    
    
    function closeSearch(){
        document.getElementById('search-trigger').classList.remove('is-open');
        document.getElementById('searchform').style.display = "none";
        window.removeEventListener( 'keydown', handleSearchKeypress );
    }


    function handleSearchKeypress(e){

        if( e.key != "Escape" ) return;
        
        if (!document.startViewTransition) {
            return closeSearch();
        }
        
        document.startViewTransition( () => closeSearch() );
        
    }

    init_search();

});